import { ERASED_LABEL, isErased } from '@/lib/erased';

function inner(v: unknown): unknown {
  return v && typeof v === 'object' ? (v as { value?: unknown }).value : undefined;
}

/** How one attribute reads on the entity page. An erased one says so, on any version, and an old shell's digest stays out of sight until the catch-up strips it. */
export function attrValue(v: unknown): string {
  if (v == null) return '—';
  if (isErased(v) || isErased(inner(v))) return ERASED_LABEL;
  if (typeof v !== 'object') return String(v);
  return JSON.stringify(v);
}

/** An erased attribute's class tag, which outlives its value. */
export function erasedAttrClass(v: unknown): string | null {
  if (!isErased(inner(v))) return null;
  const cls = (v as { class?: unknown }).class;
  return typeof cls === 'string' && cls ? cls : null;
}
